;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import cx from 'classnames';
import PropTypes from 'prop-types';

import RichText from 'components/ui/RichText';

import { getColor } from 'utils';
import { blockRootProps } from 'utils';

import styles from './BlockStaticAlertBar.module.scss';

const BlockStaticAlertBar = ({
    __typename,
    className,
    message,
    backgroundColor,
    textColor,
}) => {
    const inlineStyle = {
        backgroundColor: getColor(backgroundColor) || 'var(--colors-blue)',
        color: getColor(textColor) || 'var(--colors-cream)',
    };

    return (
        <section
            {...blockRootProps(undefined, __typename)}
            className={cx(styles.root, className)}
            style={inlineStyle}
        >
            <div className={styles.inner}>
                {message?.json && (
                    <div className={styles.copy}>
                        <RichText richText={message} />
                    </div>
                )}
            </div>
        </section>
    );
};

BlockStaticAlertBar.propTypes = {
    __typename: PropTypes.string,
    className: PropTypes.string,
    message: PropTypes.shape({
        json: PropTypes.object,
    }),
    backgroundColor: PropTypes.string,
    textColor: PropTypes.string,
};

export default BlockStaticAlertBar;
